module.exports = __webpack_public_path__ + "img/pdc-01.8867b74c.png";